<mt-card
    class="swag-paypal-settings-express"
    position-identifier="swag-paypal-settings-express"
    :title="$t('swag-paypal-settings.express.title')"
    :subtitle="$t('swag-paypal-settings.express.subtitle')"
    :is-loading="settingsStore.isLoading"
>
    <mt-banner v-if="doubleOptInConfig" variant="attention">
        {{ $t('swag-paypal-settings.express.alertMessage') }}
    </mt-banner>
    <mt-banner v-if="phoneRequiredConfig" variant="attention">
        <i18n-t keypath="swag-paypal-settings.express.alertMessagePhone" tag="p">
            <template #url>
                <a href="https://www.paypal.com/businessmanage/preferences/website" target="_blank">{{ $t('swag-paypal-settings.express.alertMessagePhoneLink') }}</a>
            </template>
        </i18n-t>
    </mt-banner>

    <swag-paypal-setting path="SwagPayPal.settings.ecsDetailEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.ecsCartEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.ecsOffCanvasEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.ecsLoginEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.ecsListingEnabled" />

    <swag-paypal-setting
        path="SwagPayPal.settings.ecsButtonColor"
        :options="buttonColorOptions"
        :disabled="ecsSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.ecsButtonShape"
        :options="buttonShapeOptions"
        :disabled="ecsSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.ecsButtonLanguageIso"
        :disabled="ecsSettingsDisabled"
    >
        <template #content="props">
            <swag-paypal-settings-locale-select
                :name="props.path"
                :disabled="props.disabled"
                :value="props.currentValue"
                @update:value="props.updateCurrentValue"
            />
        </template>
    </swag-paypal-setting>

    <swag-paypal-setting
        path="SwagPayPal.settings.ecsShowPayLater"
        :disabled="ecsSettingsDisabled"
    />
</mt-card>

<mt-card
    class="swag-paypal-settings-installment"
    position-identifier="swag-paypal-settings-installment"
    :title="$t('swag-paypal-settings.installment.title')"
    :subtitle="$t('swag-paypal-settings.installment.subtitle')"
    :is-loading="settingsStore.isLoading"
>
    <swag-paypal-setting path="SwagPayPal.settings.installmentBannerDetailPageEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.installmentBannerCartEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.installmentBannerOffCanvasCartEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.installmentBannerLoginPageEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.installmentBannerFooterEnabled" />
</mt-card>

<mt-card
    class="swag-paypal-settings-spb"
    position-identifier="swag-paypal-settings-spb"
    :is-loading="settingsStore.isLoading"
>
    <template #title>
        <swag-paypal-setting
            :bordered="false"
            :label="$t('swag-paypal-settings.spb.title')"
            path="SwagPayPal.settings.spbCheckoutEnabled"
            class="sw-card__title"
        />
    </template>

    <swag-paypal-setting
        path="SwagPayPal.settings.spbAlternativePaymentMethodsEnabled"
        :disabled="sbpSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbShowPayLater"
        :disabled="sbpSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbButtonColor"
        :disabled="sbpSettingsDisabled"
        :options="buttonColorOptions"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbButtonShape"
        :disabled="sbpSettingsDisabled"
        :options="buttonShapeOptions"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbButtonLanguageIso"
        :disabled="sbpSettingsDisabled"
    >
        <template #content="props">
            <swag-paypal-settings-locale-select
                :name="props.path"
                :disabled="props.disabled"
                :value="props.currentValue"
                @update:value="props.updateCurrentValue"
            />
        </template>
    </swag-paypal-setting>
</mt-card>
